import { useTranslation } from 'react-i18next'
import Button from './Button'

export default function ContinueButton({ disabled }: { disabled?: boolean }) {
  const { t } = useTranslation()

  // Pin the CTA to the bottom of the viewport on small screens so it stays
  // visible even when the page content is taller than the screen. On larger
  // screens it flows normally at the end of the page.
  return (
    <div className="sticky inset-x-0 bottom-4 z-20 md:static md:bottom-auto">
      <Button
        className="bg-primary rounded-full text-base text-white disabled:opacity-50"
        dataTestId="button-continue"
        disabled={disabled}
        title={t('shared.continue')}
        type="submit"
      />
    </div>
  )
}
